import { render, staticRenderFns } from "./energySaving.vue?vue&type=template&id=893786b0&scoped=true&"
import script from "./energySaving.vue?vue&type=script&lang=js&"
export * from "./energySaving.vue?vue&type=script&lang=js&"
import style0 from "./energySaving.vue?vue&type=style&index=0&id=893786b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893786b0",
  null
  
)

export default component.exports